module.exports = __webpack_public_path__ + "img/eggs_filled_with_candy.67fc28d8.jpg";